/* eslint-disable camelcase */
const state = {
	user: null,
	name: null,
	domain: null,
	isLicensed: false,
	accountManagerUrl: "account.sinao.app",
	logo: null,
	loadedApps: null,
	loadedPolicies: null,
	loadedCases: null,
	loadedCollaborators: null,
	licensePlans: null,
	partner: null,
	pageSize: 10,
	offset: 0,
	search: "",
	totalRowsLicense: 0
};

export default state;
